import { Component, OnInit, Input } from '@angular/core';
import { merchants } from './constants';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';
import { EventDetails } from '../../common/tracking/aws-tracker';

@Component({
  selector: 'zest-gc-redeem-info',
  templateUrl: './gc-redeem-info.component.html',
  styleUrls: ['./gc-redeem-info.component.scss']
})
export class GcRedeemInfoComponent implements OnInit {

  @Input() merchantKey: string;

  public merchant = null;
  constructor(
    private awsTrackingService: AwsTrackingService,
  ) {
  }

  ngOnInit() {
    this.merchant = merchants[this.merchantKey] && merchants[this.merchantKey];
  }
  track(e) {
    this.awsTrackingService.gtmTriggerEvent(e);
    const event = new EventDetails(e, 'event', 'triggered');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
  }
}
